import { React } from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container text-center">
        <span className="text-muted">by <a id="footer-link" href="https://github.com/barbaraaliverti" target="blank" className="text-muted">bárbara</a></span>
      </div>
    </footer>
  )
}

export default Footer;